var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 104,
    viewBox: "0 0 144 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.589844 15.1024H128.533C136.749 15.1024 143.41 20.7371 143.41 27.6878V90.6146C143.41 97.5653 136.749 103.2 128.533 103.2H71.9998H15.4669C7.25054 103.2 0.589844 97.5653 0.589844 90.6146V15.1024Z",
    fill: "#496EE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.589844 33.9805V85.5805C0.589844 92.5312 7.25054 98.1659 15.4669 98.1659H128.533C136.749 98.1659 143.41 92.5312 143.41 85.5805V32.722C143.41 25.7712 136.749 20.1366 128.533 20.1366H66.049V26.4293C66.049 30.5997 62.0526 33.9805 57.1228 33.9805H0.589844Z",
    fill: "url(#paint0_linear_1777_15450)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.589844 10.0683C0.589844 4.50773 5.9184 0 12.4915 0H54.1473C60.7205 0 66.049 4.50773 66.049 10.0683V15.1024H0.589844V10.0683Z",
    fill: "#496EE9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_15450",
    x1: 0.589844,
    y1: 0,
    x2: 171.553,
    y2: 121.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D77FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolderIcon);
export default __webpack_public_path__ + "static/media/blue-folder-icon.e6f415cdb4bd4e86decd087e1dcf60d3.svg";
export { ForwardRef as ReactComponent };